import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

// Definimos una interfaz para asegurar que los datos que lleguen tengan la forma correcta.
export interface JsonDialogData {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  jsonData: any;
}

@Component({
  selector: 'app-json-viewer-dialog',
  templateUrl: './json-viewer-dialog.component.html',
  styleUrls: ['./json-viewer-dialog.component.scss'],
  standalone: false,
})
export class JsonViewerDialogComponent {
  data = inject<JsonDialogData>(MAT_DIALOG_DATA);
}
